import api from './api';

export const clientService = {
  async getAll() {
    const response = await api.get('/clients');
    return response.data;
  },

  async getById(id) {
    const response = await api.get(`/clients/${id}`);
    return response.data;
  },

  async create(clientData) {
    const response = await api.post('/clients', clientData);
    return response.data;
  },

  async update(id, clientData) {
    const response = await api.put(`/clients/${id}`, clientData);
    return response.data;
  },

  async delete(id) {
    await api.delete(`/clients/${id}`);
  },

  async search(searchTerm) {
    const response = await api.get(`/clients/search?searchTerm=${encodeURIComponent(searchTerm)}`);
    return response.data;
  },

  async importFromExcel(file) {
    if (!file) {
      throw new Error('Niciun fișier selectat');
    }

    if (!(file instanceof File)) {
      throw new Error('Fișier invalid');
    }

    const formData = new FormData();
    formData.append('file', file);

    // Log for debugging
    console.log('Uploading file:', {
      name: file.name,
      type: file.type,
      size: file.size
    });

    try {
      const response = await api.post('/clients/import', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Import error:', error.response?.data || error.message);
      throw error;
    }
  },

  async exportToExcel() {
    const response = await api.get('/clients/export', {
      responseType: 'blob',
    });
    return response.data;
  },

  async getImportTemplate() {
    const response = await api.get('/clients/import-template', {
      responseType: 'blob',
    });
    return response.data;
  },

  async checkFiscalCode(fiscalCode, excludeId = null) {
    const params = excludeId ? `?excludeId=${excludeId}` : '';
    const response = await api.get(`/clients/check-fiscal-code/${fiscalCode}${params}`);
    return response.data;
  },

  async getStatistics() {
    const response = await api.get('/clients/statistics');
    return response.data;
  }
};